import { z } from 'zod'

export const PaymentStatusSchema = z.number().transform((value) => {
  switch (value) {
    case 1:
      return 'Approved'
    case 2:
      return 'Declined'
    case 3:
      return 'In review - LEGACY DO NOT USE'
    case 4:
      return 'In review Admin'
    case 5:
      return 'In review Provider'
    case 6:
      return 'In review Applicant'
    case 7:
      return 'Appeal awaiting decision'
    case 8:
      return 'Declined by Admin'
    case 9:
      return 'Declined by Provider'
    case 10:
      return 'Declined by Applicant'
    case 11:
      return 'Refunded by Provider'
    case 12:
      return 'Appeal Declined by Admin'
    default:
      return 'Unknown'
  }
})
export type PaymentStatus = z.infer<typeof PaymentStatusSchema>
